<template>
  <div class="Crisis_evaluation_view">
      
    <el-descriptions class="margin-top" :column="4"  border>
<!-- v-else-if="(pdroleid(1063) || pdroleid(1089)) -->


      <el-descriptions-item>
        <template slot="label">
          姓名
        </template>
        {{ datas.RealName }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          性别
        </template>
        {{ datas.Sex }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          年龄
        </template>
        {{ datas.Age }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          学号
        </template>
        {{ datas.UserID }}
      </el-descriptions-item>

      <el-descriptions-item span="3" v-if="!(pdroleid(1063) || pdroleid(1089))">
        <template slot="label">
          近期情绪状态如何
        </template>
        {{ sys_Forms[1].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item v-if="!(pdroleid(1063) || pdroleid(1089))">
        <template slot="label">
          持续时间
        </template>
        {{ sys_Forms[2].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="3" v-if="!(pdroleid(1063) || pdroleid(1089))">
        <template slot="label">
          现实事件刺激影响
        </template>
        {{ sys_Forms[5].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item v-if="!(pdroleid(1063) || pdroleid(1089))">
        <template slot="label">
          有无自杀自伤想法或行为
        </template>

        <span v-for="(item,i) in sys_Forms[7].Bobbies" :key="i" >
          <span v-if="sys_Forms[7].FormValue == item.Value">{{item.Name}}</span>
        </span> 

      </el-descriptions-item>

      <el-descriptions-item span="4" v-if="!(pdroleid(1063) || pdroleid(1089))">
        <template slot="label">
          自杀自伤想法或行为
        </template>
        {{ sys_Forms[7].Bobbies[1].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="3" v-if="!(pdroleid(1063) || pdroleid(1089))">
        <template slot="label">
          保护因素
        </template>
        {{ sys_Forms[8].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item v-if="!(pdroleid(1063) || pdroleid(1089))">
        <template slot="label">
          自杀危机状态
        </template>
        <span v-for="(item,i) in sys_Forms[9].Bobbies" :key="i" >
          <span v-if="sys_Forms[9].FormValue == item.Value">{{item.Name}}</span>
        </span> 
      </el-descriptions-item>

      <el-descriptions-item v-if="!(pdroleid(1063) || pdroleid(1089))">
        <template slot="label">
          精神疾病治疗史
        </template>
        <span v-for="(item,i) in sys_Forms[12].Bobbies" :key="i" >
          <span v-if="sys_Forms[12].FormValue == item.Value">{{item.Name}}</span>
        </span> 
      </el-descriptions-item>

      <el-descriptions-item span="3" v-if="!(pdroleid(1063) || pdroleid(1089))">
        <template slot="label">
          诊断结果
        </template>
        {{ sys_Forms[13].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="4" v-if="!(pdroleid(1063) || pdroleid(1089))">
        <template slot="label">
          治疗情况
        </template>
        {{ sys_Forms[14].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="3" v-if="!(pdroleid(1063) || pdroleid(1089))">
        <template slot="label">
          家族史
        </template>
        {{ sys_Forms[15].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item v-if="!(pdroleid(1063) || pdroleid(1089))">
        <template slot="label">
          是否有物质依赖
        </template>

        <span v-for="(item,i) in sys_Forms[16].Bobbies" :key="i" >
          <span v-if="sys_Forms[16].FormValue == item.Value">{{item.Name}}</span>
        </span> 


      </el-descriptions-item>

      <el-descriptions-item span="2" v-if="!(pdroleid(1063) || pdroleid(1089))">
        <template slot="label">
          是否愿意寻求心理咨询帮助
        </template>
        {{ sys_Forms[18].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="2" v-if="!(pdroleid(1063) || pdroleid(1089))">
        <template slot="label">
          是否愿意就医
        </template>
        {{ sys_Forms[19].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="4" v-if="!(pdroleid(1063) || pdroleid(1089))">
        <template slot="label">
          备注
        </template>
        {{ sys_Forms[20].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="1">
        <template slot="label">
          访谈后风险等级
        </template>
        <span v-for="(item,i) in sys_Forms[22].Bobbies" :key="i" >
          <span v-if="sys_Forms[22].FormValue == item.Value">{{item.Name}}</span>
        </span>
      </el-descriptions-item>

      <el-descriptions-item span="3"  v-if="!(pdroleid(1063) || pdroleid(1089))">
        <template slot="label">
          风险调整原因
        </template>
        {{ sys_Forms[23].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="4" >
        <template slot="label">
          访谈建议
        </template>
        {{ sys_Forms[25].FormValue }}
      </el-descriptions-item>


      <el-descriptions-item span="4" >
        <template slot="label">
          访谈前风险等级
        </template>
        {{ shenhe.Result }}
      </el-descriptions-item>

      <el-descriptions-item span="4" v-if="(pdroleid(1063) || pdroleid(1089))">
        <template slot="label">
          	风险监控员审核意见
        </template>
        {{ shenhe.RiskMonitorReviewDetail }}
      </el-descriptions-item>

      <el-descriptions-item span="4" v-if="(pdroleid(1063) || pdroleid(1089))">
        <template slot="label">
          危机主管审核意见
        </template>
        {{ shenhe.CriAdminReviewDetail }}
      </el-descriptions-item>




    </el-descriptions>

      <div v-if="this.Global.pdroleid(1069) || this.Global.pdroleid(1068) || this.Global.pdroleid(1070)">
        <p style="padding: 20px;">风险监控员初核意见</p>
        <el-checkbox-group style="margin-left: 20px;" :disabled="true" :max="3" v-model="shenhe.riskMonitorChecks">
          <el-checkbox label="1" name="type">信息不完整</el-checkbox>
          <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
          <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
          <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
        </el-checkbox-group>
        <el-input style="padding:20px;width:90%;" :disabled="true" type="textarea" v-model="shenhe.riskMonitorCheckDetail"></el-input>
      </div>

      <div v-if="this.Global.pdroleid(1068) || this.Global.pdroleid(1070)">
        <p style="padding: 20px;">危机主管复核意见</p>
        <el-checkbox-group style="margin-left: 20px;" :disabled="true" :max="3" v-model="shenhe.criAdminChecks">
          <el-checkbox label="1" name="type">信息不完整</el-checkbox>
          <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
          <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
          <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
        </el-checkbox-group>
        <el-input style="padding:20px;width:90%;" :disabled="true" type="textarea"  v-model="shenhe.criAdminCheckDetail"></el-input>
      </div>

      <div v-if="this.Global.pdroleid(1068) || this.Global.pdroleid(1070)">
        <p style="padding: 20px;">中心主任审核意见</p>
        <el-checkbox-group style="margin-left: 20px;" :disabled="true" :max="3" v-model="shenhe.centerDirectorChecks">
          <el-checkbox label="1" name="type">信息不完整</el-checkbox>
          <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
          <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
          <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
        </el-checkbox-group>
        <el-input style="padding: 20px;width: 90%;" :disabled="true" type="textarea" v-model="shenhe.centerDirectorCheckDetail"></el-input>
      </div>
      
  </div>
</template>
<script>
export default {
  data() {
    return {
      shenhe: {
        Result: '',//访谈前风险等级
        riskMonitorChecks: [],//风险监控员审核意见
        riskMonitorCheckDetail: '',//风险监控员审核详细意见
        criAdminChecks: [],//危机主管审核意见
        criAdminCheckDetail: '',//危机主管审核详细意见
        centerDirectorChecks: [],//中心主任审核意见
        centerDirectorCheckDetail: '',//中心主任审核详细意见"
        RiskMonitorReviewDetail: '',//风险监控员定级审核内容
        CriAdminReviewDetail: '',//危机主管定级审核内容
      },
      keyNo: '',
      RoleID: '',
      PublishID:'',
      UserID: '',
      datas: [],
      sys_Forms: [],
    }
  },
  methods: {
    pdroleid(id) {
      var RoleID = sessionStorage.getItem('RoleID');
      if (RoleID.indexOf(id) !== -1) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.RoleID = sessionStorage.getItem('RoleID');
    this.PublishID = [this.$route.query.PublishID][0];
    this.keyNo = [this.$route.query.KeyNo][0];
    this.UserID = [this.$route.query.UserID][0];
    
    this.$Http_Post('/CrisisWarning/GetFormView', { TableName: "新生心理普测访谈记录表", PublishID: this.PublishID, UserID: this.UserID }).then((res) => {
      if (res.Code == 200 || res.Code == 0 && res.Data) {
        this.datas = res.Data;
        this.sys_Forms = res.Data.sys_Forms;
      }
    });



    this.$Http_Post('/DistressPrediction/PrefabricatedTableData', { keyNo: this.keyNo }).then((res) => {
      if (res.Code == 0) {
        this.shenhe = {
          riskMonitorChecks: res.Data.riskMonitorChecks,//风险监控员审核意见
          riskMonitorCheckDetail: res.Data.riskMonitorCheckDetail,//风险监控员审核详细意见
          criAdminChecks: res.Data.criAdminChecks,//危机主管审核意见
          criAdminCheckDetail: res.Data.criAdminCheckDetail,//危机主管审核详细意见
          centerDirectorChecks: res.Data.centerDirectorChecks,//中心主任审核意见
          centerDirectorCheckDetail: res.Data.centerDirectorCheckDetail,//中心主任审核详细意见
          RiskMonitorReviewDetail: res.Data.RiskMonitorReviewDetail,//风险监控员定级审核内容
          CriAdminReviewDetail: res.Data.CriAdminReviewDetail,//危机主管定级审核内容
          Result: res.Data.Result,//访谈前风险等级
        }
      }
    });




  }
}

</script>

<style>
.Crisis_evaluation_view{width: 100%;height: 100%;background-color: #fff;overflow: auto;}
.Crisis_evaluation_view .el-descriptions{width: 98%;margin-left: 1%;padding-top: 20px;}
</style>